import React, { useState, useEffect } from 'react';
import ScoringBubble from './scoringBubble';
import '../../../../css/huerto/scoringMatrix.css';

const ScoringMatrix = props => {
    const [pos1, setPos1] = useState('0');
    const [pos2, setPos2] = useState('0');
    const [pos3, setPos3] = useState('0');
    const [pos4, setPos4] = useState('0');
    const [pos5, setPos5] = useState('0');
    const [pos6, setPos6] = useState('0');
    const [pos7, setPos7] = useState('0');
    const [pos8, setPos8] = useState('0');
    const [pos9, setPos9] = useState('0');
    const [matrixData, setMatrixData] = useState([]);

    useEffect(() => {
        setMatrixData(props.matrixData);
    }, [props.matrixData]);

    useEffect(() => {
        setMatrixData_pos(matrixData);
    }, [matrixData]);

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);

    const bubbleClick = event => {
        if (event && event.currentTarget) {
            let contracts = event.currentTarget.innerText;
            let element = event.currentTarget;
            if (contracts) {
                props.setContractsSelected(
                    props.contractsSelected + parseInt(contracts)
                );
                if (element.className.indexOf('selected') === -1) {
                    if (
                        props.contractColors.indexOf(
                            element.className.match(/color-[a-zA-Z]*/)[0]
                        ) === -1
                    ) {
                        props.contractColors.push(
                            element.className.match(/color-[a-zA-Z]*/)[0]
                        );
                        props.setContractColors(props.contractColors);
                        event.currentTarget.classList.add('selected');
                    }
                } else {
                    let newContracts = [];
                    // eslint-disable-next-line array-callback-return
                    props.contractColors.map(item => {
                        if (
                            item !==
                            element.className.match(/color-[a-zA-Z]*/)[0]
                        ) {
                            newContracts.push(item);
                        }
                    });
                    props.setContractColors(newContracts);
                    props.setContractsSelected(
                        props.contractsSelected - contracts
                    );
                    event.currentTarget.classList.remove('selected');
                }
            }
        }
    };

    const setMatrixData_pos = data => {
        if (data !== null && data !== undefined) {
            for (var i = 0; i < data.length; i++) {
                switch (data[i].Category) {
                    case 'CA':
                        setPos1(data[i].Amount);
                        break;
                    case 'BA':
                        setPos2(data[i].Amount);
                        break;
                    case 'AA':
                        setPos3(data[i].Amount);
                        break;
                    case 'CB':
                        setPos4(data[i].Amount);
                        break;
                    case 'BB':
                        setPos5(data[i].Amount);
                        break;
                    case 'AB':
                        setPos6(data[i].Amount);
                        break;
                    case 'CC':
                        setPos7(data[i].Amount);
                        break;
                    case 'BC':
                        setPos8(data[i].Amount);
                        break;
                    case 'AC':
                        setPos9(data[i].Amount);
                        break;

                    default:
                        break;
                }
            }
        }
    };
    var _marginLeft = false;

    if (window.performance) {
        var msie = window.navigator.userAgent.indexOf('.NET ');
        if (msie > 0)
            // If Internet Explorer, return version number
            _marginLeft = true;
    }
    return (
        <React.Fragment>
            <div
                className="o-layout o-layout--equal-height u-1/1 scoring-table-layout"
                style={_marginLeft ? { marginLeft: '15%' } : { margin: 'auto' }}
            >
                <div className="o-layout__item border-1-1-item u-3/12">
                    <ScoringBubble
                        position={1}
                        contracts={pos1}
                        color={3}
                        bubbleClick={bubbleClick}
                    />
                </div>
                <div className="o-layout__item border-1-2-item u-3/12">
                    <ScoringBubble
                        position={2}
                        contracts={pos2}
                        color={2}
                        bubbleClick={bubbleClick}
                    />
                </div>
                <div className="o-layout__item border-1-3-item u-3/12">
                    <div className="border-1-3-item-inner">
                        <ScoringBubble
                            position={3}
                            contracts={pos3}
                            color={1}
                            bubbleClick={bubbleClick}
                        />
                    </div>
                </div>
                <div className="o-layout__item u-2/12">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.006"
                        height="15"
                        viewBox="0 0 19.006 15"
                    >
                        <path
                            id="Shape"
                            d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                            transform="translate(0.503 0.5)"
                            fill="#fff"
                            stroke="#25cc99"
                            strokeWidth="1"
                        />
                    </svg>
                </div>

                <div className="o-layout__item border-2-1-item u-3/12">
                    <ScoringBubble
                        position={4}
                        contracts={pos4}
                        color={6}
                        bubbleClick={bubbleClick}
                    />
                </div>
                <div className="o-layout__item border-2-2-item u-3/12">
                    <div className="border-2-2-item-inner">
                        <ScoringBubble
                            position={5}
                            contracts={pos5}
                            color={5}
                            bubbleClick={bubbleClick}
                        />
                    </div>
                </div>
                <div className="o-layout__item border-2-3-item u-3/12">
                    <ScoringBubble
                        position={6}
                        contracts={pos6}
                        color={4}
                        bubbleClick={bubbleClick}
                    />
                </div>
                <div className="o-layout__item u-2/12">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.006"
                        height="15"
                        viewBox="0 0 19.006 15"
                    >
                        <path
                            id="Shape"
                            d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                            transform="translate(0.503 0.5)"
                            fill="#fff"
                            stroke="#ffbe48"
                            strokeWidth="1"
                        />
                    </svg>
                </div>

                <div
                    className="o-layout__item border-3-1-item u-3/12"
                    style={{ borderBottom: '0px' }}
                >
                    <ScoringBubble
                        position={7}
                        contracts={pos7}
                        color={9}
                        bubbleClick={bubbleClick}
                    />
                </div>
                <div
                    className="o-layout__item border-3-2-item u-3/12"
                    style={{ borderBottom: '0px' }}
                >
                    <ScoringBubble
                        position={8}
                        contracts={pos8}
                        color={8}
                        bubbleClick={bubbleClick}
                    />
                </div>
                <div
                    className="o-layout__item border-3-3-item u-3/12"
                    style={{ borderBottom: '0px' }}
                >
                    <ScoringBubble
                        position={9}
                        contracts={pos9}
                        color={7}
                        bubbleClick={bubbleClick}
                    />
                </div>
                <div className="o-layout__item u-2/12">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.006"
                        height="15"
                        viewBox="0 0 19.006 15"
                    >
                        <path
                            d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                            transform="translate(0.503 0.5)"
                            fill="#fff"
                            stroke="#ff5757"
                            strokeWidth="1"
                        />
                    </svg>
                </div>

                <div className="o-layout__item u-3/12 contract-header-div">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11.47"
                        height="15.777"
                        viewBox="0 0 11.47 15.777"
                    >
                        <path
                            d="M9,7.88A3.38,3.38,0,1,1,12.375,4.5,3.38,3.38,0,0,1,9,7.88ZM9,2.245A2.255,2.255,0,1,0,11.25,4.5,2.255,2.255,0,0,0,9,2.245ZM12.794,16.9H5.206L3.265,10.425l.413-.215A11.277,11.277,0,0,1,9,9a11.491,11.491,0,0,1,5.322,1.21l.413.215Zm-6.75-1.125h5.913l1.43-4.765A10.625,10.625,0,0,0,9,10.125a10.215,10.215,0,0,0-4.387.88Z"
                            transform="translate(-3.265 -1.12)"
                            fill="#ff5757"
                            fillRule="evenodd"
                        />
                    </svg>
                </div>
                <div className="o-layout__item u-3/12 contract-header-div">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11.47"
                        height="15.777"
                        viewBox="0 0 11.47 15.777"
                    >
                        <path
                            d="M9,7.88A3.38,3.38,0,1,1,12.375,4.5,3.38,3.38,0,0,1,9,7.88ZM9,2.245A2.255,2.255,0,1,0,11.25,4.5,2.255,2.255,0,0,0,9,2.245ZM12.794,16.9H5.206L3.265,10.425l.413-.215A11.277,11.277,0,0,1,9,9a11.491,11.491,0,0,1,5.322,1.21l.413.215Zm-6.75-1.125h5.913l1.43-4.765A10.625,10.625,0,0,0,9,10.125a10.215,10.215,0,0,0-4.387.88Z"
                            transform="translate(-3.265 -1.12)"
                            fill="#ffbe48"
                            fillRule="evenodd"
                        />
                    </svg>
                </div>
                <div className="o-layout__item u-3/12 contract-header-div">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11.47"
                        height="15.777"
                        viewBox="0 0 11.47 15.777"
                    >
                        <path
                            d="M9,7.88A3.38,3.38,0,1,1,12.375,4.5,3.38,3.38,0,0,1,9,7.88ZM9,2.245A2.255,2.255,0,1,0,11.25,4.5,2.255,2.255,0,0,0,9,2.245ZM12.794,16.9H5.206L3.265,10.425l.413-.215A11.277,11.277,0,0,1,9,9a11.491,11.491,0,0,1,5.322,1.21l.413.215Zm-6.75-1.125h5.913l1.43-4.765A10.625,10.625,0,0,0,9,10.125a10.215,10.215,0,0,0-4.387.88Z"
                            transform="translate(-3.265 -1.12)"
                            fill="#25cc99"
                            fillRule="evenodd"
                        />
                    </svg>
                </div>
                <div className="o-layout__item u-3/12" />
            </div>
        </React.Fragment>
    );
};

export default ScoringMatrix;
